import { render, staticRenderFns } from "./PaymentBatchProfile.vue?vue&type=template&id=796d502e"
import script from "./PaymentBatchProfile.vue?vue&type=script&lang=js"
export * from "./PaymentBatchProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports